import React from 'react';

export const ToastError = msg => {
  return (
    <div className="toast-inner error">
      <span className="toast-message">{msg}</span>
    </div>
  );
};
